<template>
  <v-dialog v-model="modal_open_all" width="400">
    <v-card class="pa-2">
      <div class="text-center">
        <v-icon class="mt-4" color="primary" size="80"
          >mdi-help-circle-outline</v-icon
        >
        <p class="text-h5 mt-2 mb-1">Are you sure?</p>
        <p>
          This will open
          <strong>{{ $store.state.search.open_all_count }} URLs</strong>
          in your browser.
        </p>
      </div>

      <div class="d-flex justify-space-between mt-10">
        <v-btn text color="grey" @click="modal_open_all = false">
          CANCEL
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$store.dispatch('openAll', { checkCount: false })"
        >
          YES, OPEN ALL
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalOpenAll",
  data() {
    return {};
  },
  computed: {
    modal_open_all: {
      get() {
        return this.$store.state.search.modal_open_all;
      },
      set(value) {
        this.$store.commit("updateStateSearch", { modal_open_all: value });
      },
    },
  },
};
</script>
